import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import type { ChangeEvent } from "react";
import { useState } from "react";

interface YesNoSubInputProps {
  defaultValue: boolean | null;
  onInputChange?: (...values: unknown[]) => void;
  disabled?: boolean;
}

function YesNoSubInput({
  defaultValue,
  onInputChange,
  disabled,
}: YesNoSubInputProps){
  const [value, setValue] = useState<boolean | null>(defaultValue);
  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const newValue = e.target.value === "true";
    setValue(newValue);
    if (onInputChange) {
      onInputChange(newValue);
    }
  };

  return (
    <RadioGroup>
      <FormControlLabel
        control={
          <Radio
            checked={value === true}
            disabled={disabled ? value === true : false}
            onChange={onChange}
          />
        }
        label="Yes"
        value
      />
      <FormControlLabel
        control={
          <Radio
            checked={value === false}
            disabled={disabled ? value === true : false}
            onChange={onChange}
          />
        }
        label="No"
        value={false}
      />
    </RadioGroup>
  );
}

export default YesNoSubInput;
